export class QuestionStructure {
  public questionText: string;
  public options: AnswerStructure[];

  constructor(text: string, optionNames: string[]) {
    this.questionText = text;
    this.options = [];
    for (let optionName of optionNames) {
      this.options.push(new AnswerStructure(optionName));
    }
  }
}

export class AnswerStructure {
  public answerText: string;
  public checked: boolean;

  constructor(text: string) {
    this.answerText = text;
    this.checked = false;
  }
}


// WEBPACK FOOTER //
// ./src/tools/question.ts